// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2iBvg","range":"MonthRangeSwitch_range__36wt3","disabled":"MonthRangeSwitch_disabled__2PFjS"};